<template>
  <div class="ContentCss">
    <el-card>
      <el-form ref="form" label-width="80px" size="mini" :inline="true">
        <el-form-item>
          <el-date-picker
            v-model="Time"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="dealercode"
            placeholder="请输入经销商代码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="vtype">
            <el-option label="售前" value="0"></el-option>
            <el-option
              v-if="
                admininfo.id == 'SA13021' ||
                admininfo.id == '35923' ||
                admininfo.id == '35215' ||
                admininfo.id == '38926' ||
                admininfo.id == '51557'
              "
              label="售后"
              value="1"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="Search">搜 索(浙江)</el-button>
          <el-button type="primary" @click="DownLoadPngFun">下 载</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card id="DownloadContent">
      <div class="Title">{{ CheckTime }} &nbsp;&nbsp; 系统使用日报</div>
      <el-row v-if="isShow" type="flex" justify="center" :gutter="20">
        <el-col :span="24">
          <div class="SM">
            <p>展厅使用情况</p>
            <p>首次进店</p>
            <div v-if="YCcount != SCJD.length">
              <div v-if="UploadcountAll != 0">
                <div v-for="item in SCJD">
                  <p
                    v-if="
                      item.Receptioncount > item.upvoicecount &&
                      item.Receptioncount != 0
                    "
                  >
                    【<span>{{ item.truename }}</span
                    >】上传【<span>{{ item.upvoicecount }}</span
                    >】条录音，但前台登记数有【<span>{{
                      item.Receptioncount
                    }}</span
                    >】条
                  </p>
                  <p
                    v-else-if="
                      item.upvoicecount > item.Receptioncount &&
                      item.upvoicecount != 0
                    "
                  >
                    【<span>{{ item.truename }}</span
                    >】当日前台登记【<span>{{ item.Receptioncount }}</span
                    >】条录音，但有【<span>{{ item.upvoicecount }}</span
                    >】条录音上传
                  </p>
                </div>
              </div>
              <div v-else>
                【<span>全店</span>】当日上传率100%
                <div class="VisibilityCss">111111</div>
              </div>
            </div>
            <div v-else>
              【<span>全店</span>】无使用记录
              <div class="VisibilityCss">111111</div>
            </div>
            <template v-if="admininfo.userid == 'A02113'">
              <p>再次进店</p>
              <div v-if="YCcount2 != SCJD2.length">
                <div v-if="UploadcountAll2 != 0">
                  <div v-for="item in SCJD2">
                    <p
                      v-if="
                        item.Receptioncount2 > item.upvoicecount2 &&
                        item.Receptioncount2 != 0
                      "
                    >
                      【<span>{{ item.truename }}</span
                      >】上传【<span>{{ item.upvoicecount2 }}</span
                      >】条录音，但前台登记数有【<span>{{
                        item.Receptioncount2
                      }}</span
                      >】条
                    </p>
                    <p
                      v-else-if="
                        item.upvoicecount2 > item.Receptioncount2 &&
                        item.upvoicecount2 != 0
                      "
                    >
                      【<span>{{ item.truename }}</span
                      >】当日前台登记【<span>{{ item.Receptioncount2 }}</span
                      >】条录音，但有【<span>{{ item.upvoicecount2 }}</span
                      >】条录音上传
                    </p>
                  </div>
                </div>
                <div v-else>
                  【<span>全店</span>】当日上传率100%
                  <div class="VisibilityCss">111111</div>
                </div>
              </div>
            </template>
            <!-- <div v-else>
              【<span>全店</span>】无使用记录
              <div class="VisibilityCss">111111</div>
            </div> -->
            <!-- <p>虚拟号 <span> {{phpne_x_count}}</span>个已分配（总计 <span>{{resinfo.phpne_x}}</span> 个）</p> -->
            <!-- <p>维护信息</p>
            <div v-for="item in SCJD">
              <p
                v-if="
                  item.upvoicecount != 0 &&
                    item.upvoicecount > item.upvoiceCustomercount
                "
              >
                【<span>{{ item.truename }}</span>】有<span>{{
                  item.upvoicecount - item.upvoiceCustomercount
                }}</span
                >条录音未维护客户信息
                <p class="VisibilityCss">【<span>item.truename</span>】有两条录音未维护客户信息</p>
              </p>
            </div> -->
          </div>
          <div>
            <table
              cellspacing="0"
              v-if="
                admininfo.id == '28110' ||
                admininfo.id == '42579' ||
                admininfo.id == 'A02113' ||
                admininfo.id == 'HZI' ||
                admininfo.id == 'HAZ01' ||
                admininfo.id == '28120' ||
                admininfo.id == 'C933DAS01' ||
                admininfo.id == '41445'
              "
              cellpadding="0"
              class="TableCss el-table"
            >
              <tr class="el-table__row">
                <th>经销商</th>
                <th colspan="7">{{ resinfo.dealername }}</th>
              </tr>
              <tr class="el-table__row">
                <th>日期</th>
                <th colspan="7">{{ CheckTime }}</th>
              </tr>
              <tr class="el-table__row">
                <th></th>
                <th></th>
                <th colspan="3">首次进店</th>
                <th colspan="3" v-if="admininfo.id == 'HZI'">前台接待</th>
                <th
                  colspan="3"
                  v-if="
                    admininfo.id == 'HAZ01' ||
                    admininfo.id == '28120' ||
                    admininfo.id == 'C933DAS01'
                  "
                >
                  试乘试驾
                </th>
                <th
                  colspan="3"
                  v-if="
                    (admininfo.id != 'HZI' &&
                      admininfo.id != 'HAZ01' &&
                      admininfo.id != '28120' &&
                      admininfo.id != 'C933DAS01') ||
                    admininfo.id == '41445'
                  "
                >
                  再次进店
                </th>
              </tr>
              <tr class="el-table__row">
                <th></th>
                <th>人员</th>
                <th>前台登记数</th>
                <th>录音上传数</th>
                <th>录音上传率</th>
                <th>前台登记数</th>
                <th>录音上传数</th>
                <th>录音上传率</th>
              </tr>
              <tr class="el-table__row" v-for="item in SCJD">
                <th></th>
                <th>{{ item.truename }}</th>
                <th>{{ item.Receptioncount }}</th>
                <th>{{ item.upvoicecount }}</th>
                <th
                  :class="[
                    item.upvoicecount == item.Receptioncount &&
                    item.Receptioncount != 0
                      ? 'green'
                      : item.upvoicecount > item.Receptioncount &&
                        item.upvoicecount != 0
                      ? 'origne'
                      : item.Receptioncount > item.upvoicecount &&
                        item.Receptioncount != 0
                      ? 'yellow'
                      : '',
                  ]"
                >
                  {{
                    Math.ceil(
                      (item.upvoicecount / item.Receptioncount) * 100
                    ) || 0
                  }}%
                </th>
                <th
                  v-if="
                    admininfo.id != 'HAZ01' &&
                    admininfo.id != '28120' &&
                    admininfo.id != 'C933DAS01'
                  "
                >
                  {{ item.Receptioncount2 }}
                </th>
                <th
                  v-if="
                    admininfo.id != 'HAZ01' &&
                    admininfo.id != '28120' &&
                    admininfo.id != 'C933DAS01'
                  "
                >
                  {{ item.upvoicecount2 }}
                </th>
                <th
                  v-if="
                    admininfo.id != 'HAZ01' &&
                    admininfo.id != '28120' &&
                    admininfo.id != 'C933DAS01'
                  "
                  :class="[
                    item.upvoicecount2 == item.Receptioncount2 &&
                    item.Receptioncount2 != 0
                      ? 'green'
                      : item.upvoicecount2 > item.Receptioncount2 &&
                        item.upvoicecount2 != 0
                      ? 'origne'
                      : item.Receptioncount2 > item.upvoicecount2 &&
                        item.Receptioncount2 != 0
                      ? 'yellow'
                      : '',
                  ]"
                >
                  {{
                    item.Receptioncount2 == 0
                      ? 0
                      : Math.ceil(
                          (item.upvoicecount2 / item.Receptioncount2) * 100
                        ) || 0
                  }}%
                </th>
                <!-- 试乘试驾 -->
                <th
                  v-if="
                    admininfo.id == 'HAZ01' ||
                    admininfo.id == '28120' ||
                    admininfo.id == 'C933DAS01'
                  "
                >
                  {{ item.Receptioncount_sj }}
                </th>
                <th
                  v-if="
                    admininfo.id == 'HAZ01' ||
                    admininfo.id == '28120' ||
                    admininfo.id == 'C933DAS01'
                  "
                >
                  {{ item.upvoicecount_sj }}
                </th>
                <th
                  v-if="
                    admininfo.id == 'HAZ01' ||
                    admininfo.id == '28120' ||
                    admininfo.id == 'C933DAS01'
                  "
                  :class="[
                    item.upvoicecount_sj == item.Receptioncount_sj &&
                    item.Receptioncount_sj != 0
                      ? 'green'
                      : item.upvoicecount_sj > item.Receptioncount_sj &&
                        item.upvoicecount_sj != 0
                      ? 'origne'
                      : item.Receptioncount_sj > item.upvoicecount_sj &&
                        item.Receptioncount_sj != 0
                      ? 'yellow'
                      : '',
                  ]"
                >
                  {{
                    item.Receptioncount_sj == 0
                      ? 0
                      : Math.ceil(
                          (item.upvoicecount_sj / item.Receptioncount_sj) * 100
                        ) || 0
                  }}%
                </th>
              </tr>
            </table>

            <table
              cellspacing="0"
              v-else
              cellpadding="0"
              class="TableCss el-table"
            >
              <tr class="el-table__row">
                <th>经销商</th>
                <th colspan="4">{{ resinfo.dealername }}</th>
              </tr>
              <tr class="el-table__row">
                <th>日期</th>
                <th colspan="4">{{ CheckTime }}</th>
              </tr>
              <tr class="el-table__row">
                <th :rowspan="SCJD.length * 1 + 1" style="width: 100px">
                  首次进店
                </th>
                <th>人员</th>
                <th>前台登记数</th>
                <th>录音上传数</th>
                <th>录音上传率</th>
              </tr>
              <tr class="el-table__row" v-for="item in SCJD">
                <th>{{ item.truename }}</th>
                <th>{{ item.Receptioncount }}</th>
                <th>{{ item.upvoicecount }}</th>
                <th
                  :class="[
                    item.upvoicecount == item.Receptioncount &&
                    item.Receptioncount != 0
                      ? 'green'
                      : item.upvoicecount > item.Receptioncount &&
                        item.upvoicecount != 0
                      ? 'origne'
                      : item.Receptioncount > item.upvoicecount &&
                        item.Receptioncount != 0
                      ? 'yellow'
                      : '',
                  ]"
                >
                  {{
                    Math.ceil(
                      (item.upvoicecount / item.Receptioncount) * 100
                    ) || 0
                  }}%
                </th>
              </tr>
            </table>
          </div>
        </el-col>
      </el-row>
      <el-row v-else type="flex" justify="center" :gutter="20">
        <el-col :span="24">
          <div class="SM">
            <p>展厅使用情况</p>
            <p>保养接待</p>
            <div v-if="YCcount != SCJD.length">
              <div v-if="UploadcountAll != 0">
                <div v-for="item in SCJD">
                  <p
                    v-if="
                      item.Receptioncount > item.upvoicecount &&
                      item.Receptioncount != 0
                    "
                  >
                    【<span>{{ item.truename }}</span
                    >】上传【<span>{{ item.upvoicecount }}</span
                    >】条录音，但前台登记数有【<span>{{
                      item.Receptioncount
                    }}</span
                    >】条
                  </p>
                  <p
                    v-else-if="
                      item.upvoicecount > item.Receptioncount &&
                      item.upvoicecount != 0
                    "
                  >
                    【<span>{{ item.truename }}</span
                    >】当日前台登记【<span>{{ item.Receptioncount }}</span
                    >】条录音，但有【<span>{{ item.upvoicecount }}</span
                    >】条录音上传
                  </p>
                </div>
              </div>
              <div v-else>
                【<span>全店</span>】当日上传率100%
                <div class="VisibilityCss">111111</div>
              </div>
            </div>
            <div v-else>
              【<span>全店</span>】无使用记录
              <div class="VisibilityCss">111111</div>
            </div>
            <!-- <template v-if="admininfo.userid == 'A02113'">
              <p>再次进店</p>
              <div v-if="YCcount2 != SCJD2.length">
                <div v-if="UploadcountAll2 != 0">
                  <div v-for="item in SCJD2">
                    <p v-if="
                      item.Receptioncount2 > item.upvoicecount2 &&
                      item.Receptioncount2 != 0
                    ">
                      【<span>{{ item.truename }}</span>】上传【<span>{{ item.upvoicecount2 }}</span>】条录音，但前台登记数有【<span>{{
                          item.Receptioncount2
                      }}</span>】条
                    </p>
                    <p v-else-if="
                      item.upvoicecount2 > item.Receptioncount2 &&
                      item.upvoicecount2 != 0
                    ">
                      【<span>{{ item.truename }}</span>】当日前台登记【<span>{{ item.Receptioncount2 }}</span>】条录音，但有【<span>{{
                          item.upvoicecount2
                      }}</span>】条录音上传
                    </p>
                  </div>
                </div>
                <div v-else>
                  【<span>全店</span>】当日上传率100%
                  <div class="VisibilityCss">111111</div>
                </div>
              </div>
            </template> -->
            <!-- <div v-else>
              【<span>全店</span>】无使用记录
              <div class="VisibilityCss">111111</div>
            </div> -->
            <!-- <p>虚拟号 <span> {{phpne_x_count}}</span>个已分配（总计 <span>{{resinfo.phpne_x}}</span> 个）</p> -->
            <!-- <p>维护信息</p>
            <div v-for="item in SCJD">
              <p
                v-if="
                  item.upvoicecount != 0 &&
                    item.upvoicecount > item.upvoiceCustomercount
                "
              >
                【<span>{{ item.truename }}</span>】有<span>{{
                  item.upvoicecount - item.upvoiceCustomercount
                }}</span
                >条录音未维护客户信息
                <p class="VisibilityCss">【<span>item.truename</span>】有两条录音未维护客户信息</p>
              </p>
            </div> -->
          </div>
          <div>
            <!-- <table cellspacing="0" v-if="
              admininfo.id == '28110' ||
              admininfo.id == '42579' ||
              admininfo.id == 'A02113' ||
              admininfo.id == 'HZI' ||
              admininfo.id == 'HAZ01' ||
              admininfo.id == '28120' ||
              admininfo.id == 'C933DAS01' ||
              admininfo.id == '41445'
              
            " cellpadding="0" class="TableCss el-table ">
              <tr class="el-table__row">
                <th>经销商</th>
                <th colspan="7">{{ admininfo.dealername }}</th>
              </tr>
              <tr class="el-table__row">
                <th>日期</th>
                <th colspan="7">{{ CheckTime }}</th>
              </tr>
              <tr class="el-table__row">
                <th></th>
                <th></th>
                <th colspan="3">首次进店</th>
                <th colspan="3" v-if="admininfo.id == 'HZI'">前台接待</th>
                <th colspan="3"
                  v-if="admininfo.id == 'HAZ01' || admininfo.id == '28120' || admininfo.id == 'C933DAS01'">试乘试驾</th>
                <th colspan="3"
                  v-if="admininfo.id != 'HZI' && admininfo.id != 'HAZ01' && admininfo.id != '28120' && admininfo.id != 'C933DAS01'||
              admininfo.id == '41445'">
                  再次进店
                </th>
              </tr>
              <tr class="el-table__row">
                <th></th>
                <th>人员</th>
                <th>前台登记数</th>
                <th>录音上传数</th>
                <th>录音上传率</th>
                <th>前台登记数</th>
                <th>录音上传数</th>
                <th>录音上传率</th>
              </tr>
              <tr class="el-table__row" v-for="item in SCJD">
                <th></th>
                <th>{{ item.truename }}</th>
                <th>{{ item.Receptioncount }}</th>
                <th>{{ item.upvoicecount }}</th>
                <th :class="[
                  item.upvoicecount == item.Receptioncount &&
                    item.Receptioncount != 0
                    ? 'green'
                    : item.upvoicecount > item.Receptioncount &&
                      item.upvoicecount != 0
                      ? 'origne'
                      : item.Receptioncount > item.upvoicecount &&
                        item.Receptioncount != 0
                        ? 'yellow'
                        : ''
                ]">
                  {{
                      Math.ceil(
                        (item.upvoicecount / item.Receptioncount) * 100
                      ) || 0
                  }}%
                </th>
                <th v-if="admininfo.id != 'HAZ01' && admininfo.id != '28120' && admininfo.id != 'C933DAS01'">{{
                    item.Receptioncount2
                }}</th>
                <th v-if="admininfo.id != 'HAZ01' && admininfo.id != '28120' && admininfo.id != 'C933DAS01'">{{
                    item.upvoicecount2
                }}</th>
                <th v-if="admininfo.id != 'HAZ01' && admininfo.id != '28120' && admininfo.id != 'C933DAS01'" :class="[
                  item.upvoicecount2 == item.Receptioncount2 &&
                    item.Receptioncount2 != 0
                    ? 'green'
                    : item.upvoicecount2 > item.Receptioncount2 &&
                      item.upvoicecount2 != 0
                      ? 'origne'
                      : item.Receptioncount2 > item.upvoicecount2 &&
                        item.Receptioncount2 != 0
                        ? 'yellow'
                        : ''
                ]">
                  {{
                      item.Receptioncount2 == 0
                        ? 0
                        : Math.ceil(
                          (item.upvoicecount2 / item.Receptioncount2) * 100
                        ) || 0
                  }}%
                </th>
                <!-- 试乘试驾 -->
            <!-- <th v-if="admininfo.id == 'HAZ01' || admininfo.id == '28120' || admininfo.id == 'C933DAS01'">{{
                    item.Receptioncount_sj
                }}</th>
                <th v-if="admininfo.id == 'HAZ01' || admininfo.id == '28120' || admininfo.id == 'C933DAS01'">{{
                    item.upvoicecount_sj
                }}</th>
                <th v-if="admininfo.id == 'HAZ01' || admininfo.id == '28120' || admininfo.id == 'C933DAS01'" :class="[
                  item.upvoicecount_sj == item.Receptioncount_sj &&
                    item.Receptioncount_sj != 0
                    ? 'green'
                    : item.upvoicecount_sj > item.Receptioncount_sj &&
                      item.upvoicecount_sj != 0
                      ? 'origne'
                      : item.Receptioncount_sj > item.upvoicecount_sj &&
                        item.Receptioncount_sj != 0
                        ? 'yellow'
                        : ''
                ]">
                  {{
                      item.Receptioncount_sj == 0
                        ? 0
                        : Math.ceil(
                          (item.upvoicecount_sj / item.Receptioncount_sj) * 100
                        ) || 0
                  }}%
                </th>
              </tr>
            </table> -->

            <table cellspacing="0" cellpadding="0" class="TableCss el-table">
              <tr class="el-table__row">
                <th>经销商</th>
                <th colspan="4">{{ admininfo.dealername }}</th>
              </tr>
              <tr class="el-table__row">
                <th>日期</th>
                <th colspan="4">{{ CheckTime }}</th>
              </tr>
              <tr class="el-table__row">
                <th :rowspan="SCJD.length * 1 + 1" style="width: 100px">
                  保养接待
                </th>
                <th>人员</th>
                <th>前台登记数</th>
                <th>录音上传数</th>
                <th>录音上传率</th>
              </tr>
              <tr class="el-table__row" v-for="item in SCJD">
                <th>{{ item.truename }}</th>
                <th>{{ item.Receptioncount }}</th>
                <th>{{ item.upvoicecount }}</th>
                <th
                  :class="[
                    item.upvoicecount == item.Receptioncount &&
                    item.Receptioncount != 0
                      ? 'green'
                      : item.upvoicecount > item.Receptioncount &&
                        item.upvoicecount != 0
                      ? 'origne'
                      : item.Receptioncount > item.upvoicecount &&
                        item.Receptioncount != 0
                      ? 'yellow'
                      : '',
                  ]"
                >
                  {{
                    Math.ceil(
                      (item.upvoicecount / item.Receptioncount) * 100
                    ) || 0
                  }}%
                </th>
              </tr>
            </table>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row type="flex" justify="center" :gutter="20">
        <el-col :span="24">
          <div class="SM">
            <p>虚拟号使用情况</p>
            <div v-for="item in DCC">
              <p v-if="item.callcount == 0">
                【<span>{{ item.truename }}</span
                >】当日无虚拟号拨打记录
              </p>
            </div>
          </div>
          <div>
            <table cellspacing="0" cellpadding="0" class="TableCss el-table ">
              <tr class="el-table__row">
                <th>经销商</th>
                <th colspan="3">{{ admininfo.dealername }}</th>
              </tr>
              <tr class="el-table__row">
                <th>日期</th>
                <th colspan="3">{{ CheckTime }}</th>
              </tr>
              <tr class="el-table__row">
                <th :rowspan="DCC.length * 1 + 1" style="width: 100px;">
                  线索邀约
                </th>
                <th>人员</th>
                <th>呼出数</th>
                <th>虚拟号分配情况</th>
              </tr>
              <tr class="el-table__row" v-for="item in DCC">
                <th>{{ item.truename }}</th>
                <th>{{ item.callcount }}</th>
                <th>{{ item.phone_x || "未分配" }}</th>
              </tr>
            </table>
          </div>
        </el-col>
      </el-row> -->
    </el-card>
  </div>
</template>
<script>
// document.cookie = 'wxzb=userid=jtbztest&id=zb&tid=24776&username=jtbztest&truename=%e9%9b%86%e5%9b%a2%e6%b5%8b%e8%af%95&tel=&act=all&actname=all&store=&qx=0000000-0000000000000100-0-0000000000000000000-00-0-0000-000000000000-000-00-00-0-0-0-0-0-0-0-0-0&brand=&usebrand=%e6%9e%97%e8%82%af%e4%b8%ad%e5%9b%bd&groupid=5;path=/'
document.cookie =
  "wxglweb=userid=35923&id=35923&tid=26646&username=35923&truename=%e7%ae%a1%e7%90%86%e5%91%98&tel=&act=%e7%ae%a1%e7%90%86%e5%91%98&actname=%e7%ae%a1%e7%90%86%e5%91%98&qx=&login=1&nqx=1&sendmode=13&dmsid=&store=&dmsusername=&dealername=%e6%b8%a9%e5%b7%9e%e5%8a%9b%e5%ae%9d%e8%a1%8c&brand=%e5%ae%9d%e9%a9%ac&balance=0";

import { DownLoadPng } from "../../utils/DownLoadFail.js";
import qs from "qs";
export default {
  data() {
    return {
      resinfo: {},
      admininfo: {},
      vtype: "0",
      Time: new Date(new Date().getTime() - 1000 * 60 * 60 * 24).Format(
        "yyyy-MM-dd"
      ),
      CheckTime: new Date(new Date().getTime() - 1000 * 60 * 60 * 24).Format(
        "yyyy-MM-dd"
      ),
      dealercode: "",
      SCJD: [],
      DCC: [],
      phpne_x_count: 0,
      Uploadcount: 0,
      UploadcountAll: 0,
      YCcount: 0,
      SCJD2: [],
      Uploadcount2: 0,
      UploadcountAll2: 0,
      YCcount2: 0,
      all: {},
      isShow: true,
    };
  },
  methods: {
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return arr[2];
      else return null;
    },
    DownLoadPngFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      DownLoadPng("图片", "DownloadContent");
      loading.close();
    },
    // cookies 转对象
    cookieToJson() {
      console.log(document.cookie);
      let cookieArr = decodeURIComponent(this.getCookie("wxglweb")).split("&");
      console.log(cookieArr);
      let obj = {};
      cookieArr.forEach((i) => {
        let arr = i.split("=");
        obj[arr[0]] = arr[1];
      });
      console.log(obj);
      return obj;
    },
    // 搜索
    Search() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$axios
        .Getdata(
          `Manage/SetInData.aspx?action=GetDataReport&dealercode=${
            this.dealercode
          }&vtype=${this.vtype}&date=${this.Time || ""}`
        )
        .then((res) => {
          loading.close();
          if (res.data.errcode == 0) {
            if (this.vtype == 1) {
              this.isShow = false;
            } else {
              this.isShow = true;
            }
            this.CheckTime = new Date(this.Time).Format("yyyy年MM月dd日");
            this.phpne_x_count = 0;
            this.SCJD = [];
            this.SCJD2 = [];
            this.DCC = [];
            this.Uploadcount = 0;
            this.UploadcountAll = 0;
            this.YCcount = 0;
            this.Uploadcount2 = 0;
            this.UploadcountAll2 = 0;
            this.YCcount2 = 0;
            let data = res.data;
            this.resinfo = data;
            this.all = data.userlist[data.userlist.length - 1];
            data.userlist.pop();
            data.userlist.forEach((element) => {
              console.log(element.act == "销售顾问");
              console.log(element.act == "产品专家");
              console.log(element.Receptioncount != 0);
              console.log(element.upvoicecount != 0);
              console.log(element.Receptioncount_sj != 0);
              console.log(element.upvoicecount_sj != 0);
              if (
                element.act == "销售顾问" ||
                element.act == "产品专家" ||
                element.Receptioncount != 0 ||
                element.upvoicecount != 0 ||
                element.Receptioncount_sj != 0 ||
                element.upvoicecount_sj != 0
              ) {
                if (element.Receptioncount == 0 && element.upvoicecount == 0) {
                  // debugger
                  this.YCcount++;
                }
                this.SCJD.push(element);
                if (
                  element.Receptioncount == element.upvoicecount &&
                  element.upvoicecount != 0 &&
                  element.Receptioncount != 0
                ) {
                  this.Uploadcount++;
                  // 上传成功数量
                }
                if (
                  element.Receptioncount != element.upvoicecount ||
                  (element.upvoicecount == 0 && element.Receptioncount != 0) ||
                  (element.upvoicecount != 0 && element.Receptioncount == 0)
                ) {
                  this.UploadcountAll++;
                  // 异常数据量
                }

                if (
                  element.Receptioncount2 == 0 &&
                  element.upvoicecount2 == 0
                ) {
                  // debugger
                  this.YCcount2++;
                }
                this.SCJD2.push(element);
                if (
                  element.Receptioncount2 == element.upvoicecount2 &&
                  element.upvoicecount2 != 0 &&
                  element.Receptioncount2 != 0
                ) {
                  this.Uploadcount2++;
                  // 上传成功数量
                }
                if (
                  element.Receptioncount2 != element.upvoicecount2 ||
                  (element.upvoicecount2 == 0 &&
                    element.Receptioncount2 != 0) ||
                  (element.upvoicecount2 != 0 && element.Receptioncount2 == 0)
                ) {
                  this.UploadcountAll2++;
                  // 异常数据量
                }
              }
              if (
                element.callcount != 0 ||
                element.act == "DCC经理" ||
                element.act == "DCC专员" ||
                element.act == "BDC专员" ||
                element.act == "BDC主管"
              ) {
                this.DCC.push(element);
              }
              if (element.phone_x) {
                this.phpne_x_count++;
              }
            });
          }
          // if(this.all.truename == '合计') {
          //   if(this.SCJD[this.SCJD.length-1].truename != '合计') {
          //     this.SCJD.push(this.all)
          //   }
          // }
          this.SCJD.forEach((v) => {
            v.Receptioncount = Number(v.Receptioncount);
            v.upvoicecount = Number(v.upvoicecount);
          });
          this.all.Receptioncount = Number(this.all.Receptioncount);
          this.all.upvoicecount = Number(this.all.upvoicecount);
          this.SCJD.push(this.all);
          console.log(this.SCJD);
        });
    },
  },
  mounted() {
    //console.log(document.getElementById("DownloadContent"), this.SCJD);
    console.log(this.SCJD);
  },
  created() {
    //console.log(DownLoadPng);
    this.admininfo = this.cookieToJson();
    console.log(this.admininfo);
    console.log(this.admininfo.id == "28110");
    console.log(this.admininfo.id == "42579");
    console.log(this.admininfo.id == "A02113");
    this.Search();
  },
};
</script>
<style scoped>
.ContentCss {
  padding: 8px;
  box-sizing: border-box;
}

.yellow {
  background-color: #ffd100;
  color: #000;
}

.Title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.green {
  background-color: #92d050;
  color: #000;
}

.origne {
  background-color: #ff7d37;
  color: #000;
}

.TableCss {
  border: none;
  border-bottom: 1px solid #cecece;
  border-left: 1px solid #cecece;
}

.TableCss th {
  box-sizing: border-box;
  padding: 12px 12px;
  text-align: center;
  border-top: 1px solid #cecece;
  border-right: 1px solid #cecece;
}

.CenterCss {
  text-align: center;
}

.SM {
  box-sizing: border-box;
  border-radius: 2px;
  margin: 40px auto;
  border: 1px solid #cecece;
  padding: 0 20px;
  box-sizing: border-box;
}

.SM span {
  color: #6889f8;
}

.VisibilityCss {
  visibility: hidden;
}
</style>
